import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "AC", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "NonAC", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px","font-weight":"bold"} }, "自投", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "(由Webeye投放或Webeye寻找第三方投放)", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"18px","font-weight":"bold"} }, "代投", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "ml-2" }, "(由Partner投放)", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { style: {"flex-grow":"1"} }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, "AC", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("增加阶梯")
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", null, "NonAC", -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("增加阶梯")
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", null, "新客", -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_16 = { style: {"text-align":"right"} }
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_18 = { style: {"text-align":"right"} }
const _hoisted_19 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 其它区域 ")
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", null, "老客激励", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_23 = /*#__PURE__*/_createElementVNode("span", null, "新客", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("span", null, "老客激励", -1)
const _hoisted_25 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_26 = /*#__PURE__*/_createElementVNode("span", null, "新客", -1)
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 增加区域 ")
const _hoisted_28 = /*#__PURE__*/_createTextVNode("其它区域")
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_30 = /*#__PURE__*/_createElementVNode("span", null, "消耗", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("span", null, "占比", -1)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", null, "消耗", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", null, "占比", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 增加阶梯 ")
const _hoisted_36 = /*#__PURE__*/_createElementVNode("span", null, "自投（由Webeye投放或Webeye寻找第三方投放）", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode(" 增加行业 ")
const _hoisted_38 = /*#__PURE__*/_createElementVNode("span", null, "其他", -1)
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", null, "代投（由Partner投放）", -1)
const _hoisted_40 = { class: "wedialog_footer" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("增加阶梯")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("增加区域")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("确定")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_we_select = _resolveComponent("we-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_ACollapsePanel = _resolveComponent("ACollapsePanel")!
  const _component_ACollapse = _resolveComponent("ACollapse")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    visible: _ctx.dialog_visible,
    "onUpdate:visible": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.dialog_visible) = $event)),
    centered: "",
    closable: false,
    maskClosable: "",
    width: "800px",
    after_close: _ctx.after_close,
    wrapClassName: "we-dialog_container"
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_40, [
        _withDirectives(_createVNode(_component_a_button, {
          onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.add_step_item({ type: 'step' }))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_41
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.is_step_type]
        ]),
        _withDirectives(_createVNode(_component_a_button, {
          onClick: _cache[44] || (_cache[44] = ($event: any) => (_ctx.add_region({ type: 'tt' }))),
          type: "primary"
        }, {
          default: _withCtx(() => [
            _hoisted_42
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.is_tt_type]
        ]),
        _createVNode(_component_a_button, { onClick: _ctx.cancel }, {
          default: _withCtx(() => [
            _hoisted_43
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_a_button, {
          type: "primary",
          onClick: _ctx.save_data
        }, {
          default: _withCtx(() => [
            _hoisted_44
          ]),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: "media_rule_form",
        model: _ctx.model
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_row, { gutter: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_a_col, { span: 24 }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_form_item, {
                    label: "配置方式",
                    name: "rule_type",
                    rules: [_ctx.required()],
                    labelCol: _ctx.is_gg_type || _ctx.is_mb_type ? {} : { style: `width:120px` },
                    wrapperCol: _ctx.is_gg_type || _ctx.is_mb_type ? {} : { style: `max-width:calc(100% - 120px)` }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_we_select, {
                        placeholder: "请选择配置方式",
                        value: _ctx.model.rule_type,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.rule_type) = $event)),
                        options: _ctx.config_type_items
                      }, null, 8, ["value", "options"])
                    ]),
                    _: 1
                  }, 8, ["rules", "labelCol", "wrapperCol"])
                ]),
                _: 1
              }),
              (_ctx.is_normal_type)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 0,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form_item, {
                        label: _ctx.is_rebate ? '返点比例' : '服务费比例',
                        labelCol: { style: `width:120px` },
                        wrapperCol: { style: `max-width:calc(100% - 120px)` }
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_input_number, {
                            min: 0,
                            max: 1,
                            step: 0.01,
                            value: _ctx.model.default,
                            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.default) = $event)),
                            placeholder: _ctx.is_rebate ? '请填写返点比例，例0.01' : '请填写服务费比例，例0.01'
                          }, null, 8, ["step", "value", "placeholder"])
                        ]),
                        _: 1
                      }, 8, ["label", "wrapperCol"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_step_type)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.step.steps, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_col, {
                        key: index,
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_row, { gutter: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: "从",
                                    labelCol: { style: `width:120px` },
                                    wrapperCol: { style: `max-width:calc(100% - 120px)` }
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_number, {
                                        value: item.from,
                                        "onUpdate:value": ($event: any) => ((item.from) = $event),
                                        onChange: ($event: any) => (_ctx.change_from_value({ type: 'step', index }))
                                      }, null, 8, ["value", "onUpdate:value", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1032, ["wrapperCol"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 6 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, { label: "到" }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_number, {
                                        value: item.to,
                                        "onUpdate:value": ($event: any) => ((item.to) = $event),
                                        onChange: ($event: any) => (_ctx.change_to_value({ type: 'step', index }))
                                      }, null, 8, ["value", "onUpdate:value", "onChange"])
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, { span: 8 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_form_item, {
                                    label: _ctx.is_rebate ? '返点比例' : '服务费比例'
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_input_number, {
                                        min: 0,
                                        max: 1,
                                        step: 0.01,
                                        value: item.value,
                                        "onUpdate:value": ($event: any) => ((item.value) = $event),
                                        placeholder: "1%请填写0.01"
                                      }, null, 8, ["step", "value", "onUpdate:value"])
                                    ]),
                                    _: 2
                                  }, 1032, ["label"])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_a_col, {
                                span: 2,
                                class: "btn_delete_container"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "link",
                                    onClick: ($event: any) => (_ctx.delete_step_item({ type: 'step', index }))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128)),
                    _createVNode(_component_a_col, { span: 24 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_form_item, {
                          labelCol: { style: `width:120px` },
                          wrapperCol: { style: `max-width:calc(100% - 120px)` },
                          label: 
                _ctx.model.step.steps.length === 0
                  ? _ctx.is_rebate
                    ? '返点比例'
                    : '服务费比例'
                  : _ctx.is_rebate
                  ? '其它返点比例'
                  : '其它服务费比例'
              
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_input_number, {
                              min: 0,
                              max: 1,
                              step: 0.01,
                              value: _ctx.model.step.default,
                              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.step.default) = $event)),
                              placeholder: "例0.01"
                            }, null, 8, ["step", "value"])
                          ]),
                          _: 1
                        }, 8, ["wrapperCol", "label"])
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.is_gg2023_fee_type && _ctx.is_service)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 2,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg2023_fee.ac,
                                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.gg2023_fee.ac) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_2
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg2023_fee.nonac,
                                    "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.gg2023_fee.nonac) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_mb_type && _ctx.is_rebate)
                ? (_openBlock(), _createBlock(_component_a_row, {
                    key: 3,
                    type: "flex",
                    gutter: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_col, {
                        style: {"display":"flex","align-items":"baseline"},
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3,
                          _hoisted_4,
                          _hoisted_5,
                          _createElementVNode("a", {
                            class: "mr-3",
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.model.mb.webeyeBuyShowProductClass = !_ctx.model.mb.webeyeBuyShowProductClass))
                          }, _toDisplayString(_ctx.model.mb.webeyeBuyShowProductClass ? '删除' : '添加') + "分类 ", 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.model.mb.webeyeBuyShowProductClass)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 0,
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, {
                                gutter: 24,
                                type: "flex"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "Game Rebate",
                                        name: "webeyeBuyGame"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input_number, {
                                            min: 0,
                                            max: 1,
                                            step: 0.01,
                                            placeholder: "1%请填写0.01",
                                            value: _ctx.model.mb.webeyeBuyGame,
                                            "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.model.mb.webeyeBuyGame) = $event))
                                          }, null, 8, ["step", "value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "App Rebate",
                                        name: "webeyeBuyApp"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input_number, {
                                            min: 0,
                                            max: 1,
                                            step: 0.01,
                                            placeholder: "1%请填写0.01",
                                            value: _ctx.model.mb.webeyeBuyApp,
                                            "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.model.mb.webeyeBuyApp) = $event))
                                          }, null, 8, ["step", "value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: `默认${_ctx.data_item.policy_name}`,
                            name: "webeyeBuyApp"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_number, {
                                min: 0,
                                max: 1,
                                step: 0.01,
                                placeholder: "1%请填写0.01",
                                value: _ctx.model.mb.webeyeBuyDefault,
                                "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.model.mb.webeyeBuyDefault) = $event))
                              }, null, 8, ["step", "value"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_col, {
                        style: {"display":"flex","align-items":"baseline"},
                        span: 24
                      }, {
                        default: _withCtx(() => [
                          _hoisted_6,
                          _hoisted_7,
                          _hoisted_8,
                          _hoisted_9,
                          _createElementVNode("a", {
                            class: "mr-3",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.model.mb.partnerBuyShowProductClass = !_ctx.model.mb.partnerBuyShowProductClass))
                          }, _toDisplayString(_ctx.model.mb.partnerBuyShowProductClass ? '删除' : '添加') + "分类 ", 1)
                        ]),
                        _: 1
                      }),
                      (_ctx.model.mb.partnerBuyShowProductClass)
                        ? (_openBlock(), _createBlock(_component_a_col, {
                            key: 1,
                            span: 24
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, {
                                type: "flex",
                                gutter: 24
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "Game Rebate",
                                        name: "partnerBuyGame"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input_number, {
                                            min: 0,
                                            max: 1,
                                            step: 0.01,
                                            placeholder: "1%请填写0.01",
                                            value: _ctx.model.mb.partnerBuyGame,
                                            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.model.mb.partnerBuyGame) = $event))
                                          }, null, 8, ["step", "value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 12 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, {
                                        label: "App Rebate",
                                        name: "partnerBuyApp"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input_number, {
                                            min: 0,
                                            max: 1,
                                            step: 0.01,
                                            placeholder: "1%请填写0.01",
                                            value: _ctx.model.mb.partnerBuyApp,
                                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.model.mb.partnerBuyApp) = $event))
                                          }, null, 8, ["step", "value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_a_col, { span: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, {
                            label: `默认${_ctx.data_item.policy_name}`,
                            name: "partnerBuyDefault"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_input_number, {
                                min: 0,
                                max: 1,
                                step: 0.01,
                                value: _ctx.model.mb.partnerBuyDefault,
                                "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.model.mb.partnerBuyDefault) = $event)),
                                placeholder: "1%请填写0.01"
                              }, null, 8, ["step", "value"])
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_gg_type && _ctx.is_rebate)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 4,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_10,
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.add_step_item({ type: 'gg', gg_type: 'ac' })))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_11
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.gg.ac.steps, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              span: 24,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { gutter: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "从" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.from,
                                              "onUpdate:value": ($event: any) => ((item.from) = $event),
                                              onChange: ($event: any) => (_ctx.change_from_value({ type: 'gg', gg_type: 'ac', index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "到" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.to,
                                              "onUpdate:value": ($event: any) => ((item.to) = $event),
                                              onChange: ($event: any) => (_ctx.change_to_value({ type: 'gg', gg_type: 'ac', index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              min: 0,
                                              max: 1,
                                              step: 0.01,
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              placeholder: "1%请填写0.01"
                                            }, null, 8, ["step", "value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 4,
                                      class: "btn_delete_container"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: ($event: any) => (_ctx.delete_step_item({ type: 'gg', gg_type: 'ac', index }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: _ctx.model.gg.ac.steps.length === 0 ? '返点比例' : '其它返点比例'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg.ac.default,
                                    "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.model.gg.ac.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_12,
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.add_step_item({ type: 'gg', gg_type: 'nonac' })))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_13
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.gg.nonac.steps, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              span: 24,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { gutter: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "从" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.from,
                                              "onUpdate:value": ($event: any) => ((item.from) = $event),
                                              onChange: ($event: any) => (_ctx.change_from_value({ type: 'gg', gg_type: 'nonac', index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "到" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.to,
                                              "onUpdate:value": ($event: any) => ((item.to) = $event),
                                              onChange: ($event: any) => (_ctx.change_to_value({ type: 'gg', gg_type: 'nonac', index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              min: 0,
                                              max: 1,
                                              step: 0.01,
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              placeholder: "1%请填写0.01"
                                            }, null, 8, ["step", "value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 4,
                                      class: "btn_delete_container"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: ($event: any) => (_ctx.delete_step_item({ type: 'gg', gg_type: 'nonac', index }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: _ctx.model.gg.nonac.steps.length === 0 ? '返点比例' : '其它返点比例'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg.nonac.default,
                                    "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.model.gg.nonac.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_14,
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.add_step_item({ type: 'gg', gg_type: 'new_customer' })))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_15
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.gg.new_customer.steps, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              span: 24,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { gutter: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "从" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.from,
                                              "onUpdate:value": ($event: any) => ((item.from) = $event),
                                              onChange: ($event: any) => (_ctx.change_from_value({ type: 'gg', gg_type: 'new_customer', index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "到" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.to,
                                              "onUpdate:value": ($event: any) => ((item.to) = $event),
                                              onChange: ($event: any) => (_ctx.change_to_value({ type: 'gg', gg_type: 'new_customer', index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              min: 0,
                                              max: 1,
                                              step: 0.01,
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              placeholder: "1%请填写0.01"
                                            }, null, 8, ["step", "value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 4,
                                      class: "btn_delete_container"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: ($event: any) => (_ctx.delete_step_item({ type: 'gg', gg_type: 'new_customer', index }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: _ctx.model.gg.new_customer.steps.length === 0 ? '返点比例' : '其它返点比例'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg.new_customer.default,
                                    "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.model.gg.new_customer.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_tt_type && _ctx.is_rebate)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 5,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt.region_config, (item, region_index) => {
                        return (_openBlock(), _createBlock(_component_a_row, {
                          key: region_index,
                          class: "region_config_wrapper"
                        }, {
                          default: _withCtx(() => [
                            (region_index !== 0)
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 24,
                                  class: "delete_button"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_svg_icon, {
                                      "icon-name": "CloseOutlined",
                                      onClick: ($event: any) => (_ctx.delete_region_item({ type: 'tt', index: region_index }))
                                    }, null, 8, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true),
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, null, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_16, [
                                      _createVNode(_component_a_button, {
                                        type: "link",
                                        onClick: ($event: any) => (_ctx.add_step_item({ type: 'tt', region_index })),
                                        style: {"padding":"0"}
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_17
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"])
                                    ])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: "区域",
                                  labelCol: { style: `width:120px` },
                                  wrapperCol: { style: `max-width:calc(100% - 120px)` }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_we_select, {
                                      onChange: (val) => _ctx.check_uniq_region(val, region_index),
                                      value: item.region_category,
                                      "onUpdate:value": ($event: any) => ((item.region_category) = $event),
                                      placeholder: "请选择区域",
                                      options: _ctx.region_list
                                    }, null, 8, ["onChange", "value", "onUpdate:value", "options"])
                                  ]),
                                  _: 2
                                }, 1032, ["wrapperCol"])
                              ]),
                              _: 2
                            }, 1024),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.steps, (item, index) => {
                              return (_openBlock(), _createBlock(_component_a_col, {
                                span: 24,
                                key: index
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, { gutter: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 8 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: "从",
                                            labelCol: { style: `width:120px` },
                                            wrapperCol: { style: `max-width:calc(100% - 120px)` }
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input_number, {
                                                type: "text",
                                                value: item.from,
                                                "onUpdate:value": ($event: any) => ((item.from) = $event),
                                                onChange: ($event: any) => (_ctx.change_from_value({ type: 'tt', region_index, index }))
                                              }, null, 8, ["value", "onUpdate:value", "onChange"])
                                            ]),
                                            _: 2
                                          }, 1032, ["wrapperCol"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_col, { span: 6 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, { label: "到" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input_number, {
                                                type: "text",
                                                value: item.to,
                                                "onUpdate:value": ($event: any) => ((item.to) = $event),
                                                onChange: ($event: any) => (_ctx.change_to_value({ type: 'tt', region_index, index }))
                                              }, null, 8, ["value", "onUpdate:value", "onChange"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_col, { span: 8 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input_number, {
                                                min: 0,
                                                max: 1,
                                                step: 0.01,
                                                value: item.value,
                                                "onUpdate:value": ($event: any) => ((item.value) = $event),
                                                placeholder: "1%请填写0.01"
                                              }, null, 8, ["step", "value", "onUpdate:value"])
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_a_col, {
                                        span: 2,
                                        class: "btn_delete_container"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_button, {
                                            type: "link",
                                            onClick: ($event: any) => (_ctx.delete_step_item({ type: 'tt', region_index, index }))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128)),
                            _createVNode(_component_a_col, { span: 24 }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_form_item, {
                                  label: item.steps.length === 0 ? '返点比例' : '其它返点比例',
                                  labelCol: { style: `width:120px` },
                                  wrapperCol: { style: `max-width:calc(100% - 120px)` }
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_input_number, {
                                      min: 0,
                                      max: 1,
                                      step: 0.01,
                                      value: item.default,
                                      "onUpdate:value": ($event: any) => ((item.default) = $event),
                                      placeholder: "1%请填写0.01"
                                    }, null, 8, ["step", "value", "onUpdate:value"])
                                  ]),
                                  _: 2
                                }, 1032, ["label", "wrapperCol"])
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _createVNode(_component_a_row, { class: "region_config_wrapper" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_18, [
                                    _createVNode(_component_a_button, {
                                      type: "link",
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.add_step_item({ type: 'tt', region_index: _ctx.model.tt.region_config.length }))),
                                      style: {"padding":"0"}
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_19
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: "区域",
                                labelCol: { style: `width:120px` },
                                wrapperCol: { style: `max-width:calc(100% - 120px)` }
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_20
                                ]),
                                _: 1
                              }, 8, ["wrapperCol"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt.default.steps, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              span: 24,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { gutter: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, {
                                          label: "从",
                                          labelCol: { style: `width:120px` },
                                          wrapperCol: { style: `max-width:calc(100% - 120px)` }
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.from,
                                              "onUpdate:value": ($event: any) => ((item.from) = $event),
                                              onChange: ($event: any) => (_ctx.change_from_value({ type: 'tt', region_index: _ctx.model.tt.region_config.length, index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1032, ["wrapperCol"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 6 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "到" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              type: "text",
                                              value: item.to,
                                              "onUpdate:value": ($event: any) => ((item.to) = $event),
                                              onChange: ($event: any) => (_ctx.change_to_value({ type: 'tt', region_index: _ctx.model.tt.region_config.length, index }))
                                            }, null, 8, ["value", "onUpdate:value", "onChange"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              min: 0,
                                              max: 1,
                                              step: 0.01,
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              placeholder: "1%请填写0.01"
                                            }, null, 8, ["step", "value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 2,
                                      class: "btn_delete_container"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: ($event: any) => (_ctx.delete_step_item({ type: 'tt', region_index: _ctx.model.tt.region_config.length, index }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: _ctx.model.tt.default.steps.length === 0 ? '返点比例' : '其它返点比例',
                                labelCol: { style: `width:120px` },
                                wrapperCol: { style: `max-width:calc(100% - 120px)` }
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.tt.default.default,
                                    "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.model.tt.default.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              }, 8, ["label", "wrapperCol"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_gg_2023_type && _ctx.is_rebate)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 6,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21,
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.add_step_item({ type: 'gg2023', gg2023_type: 'nonac' }))),
                                disabled: _ctx.model.gg2023.nonac.steps.length === 4
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_22
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.gg2023.nonac.steps, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              span: 24,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { gutter: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "层级" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input, {
                                              type: "text",
                                              value: item.level,
                                              "onUpdate:value": ($event: any) => ((item.level) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "Target" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              value: item.target,
                                              "onUpdate:value": ($event: any) => ((item.target) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              min: 0,
                                              max: 1,
                                              step: 0.01,
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              placeholder: "1%请填写0.01"
                                            }, null, 8, ["step", "value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 4,
                                      class: "btn_delete_container"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: ($event: any) => (_ctx.delete_step_item({ type: 'gg2023', gg2023_type: 'nonac', index }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: _ctx.model.gg2023.nonac.steps.length === 0 ? '返点比例' : '其它返点比例'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg2023.nonac.default,
                                    "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.model.gg2023.nonac.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg2023.new_customer.default,
                                    "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.model.gg2023.new_customer.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_gg_2024_type && _ctx.is_rebate)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 7,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24,
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.add_step_item({ type: 'gg2024', gg2024_type: 'nonac' }))),
                                disabled: _ctx.model.gg2024.nonac.steps.length === 7
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_25
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.gg2024.nonac.steps, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              span: 24,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { gutter: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 4 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "层级" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input, {
                                              type: "text",
                                              value: item.level,
                                              "onUpdate:value": ($event: any) => ((item.level) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "Target" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              value: item.target,
                                              "onUpdate:value": ($event: any) => ((item.target) = $event),
                                              disabled: ""
                                            }, null, 8, ["value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 8 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              min: 0,
                                              max: 1,
                                              step: 0.01,
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              placeholder: "1%请填写0.01"
                                            }, null, 8, ["step", "value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 4,
                                      class: "btn_delete_container"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: ($event: any) => (_ctx.delete_step_item({ type: 'gg2024', gg2024_type: 'nonac', index }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, {
                                label: _ctx.model.gg2024.nonac.steps.length === 0 ? '返点比例' : '其它返点比例'
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg2024.nonac.default,
                                    "onUpdate:value": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.model.gg2024.nonac.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              }, 8, ["label"])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_26
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gg2024.new_customer.default,
                                    "onUpdate:value": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.model.gg2024.new_customer.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.is_tt_2023_type && _ctx.is_rebate)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 8,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ACollapse, {
                        activeKey: _ctx.activeKey,
                        "onUpdate:activeKey": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.activeKey) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ACollapsePanel, {
                            key: "基本返点（按地区配置）",
                            header: "基本返点（按地区配置）"
                          }, {
                            extra: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[27] || (_cache[27] = _withModifiers(($event: any) => (_ctx.add_region({ type: 'tt2023' })), ["stop"])),
                                disabled: _ctx.model.tt2023.region_config.length === 3
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_27
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, { gutter: 24 }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt2023.region_config, (item, index) => {
                                    return (_openBlock(), _createBlock(_component_a_col, {
                                      span: 24,
                                      key: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_row, { gutter: 24 }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_col, { span: 10 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_form_item, {
                                                  label: '区域' + (index + 1)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_we_select, {
                                                      value: item.region_category,
                                                      "onUpdate:value": ($event: any) => ((item.region_category) = $event),
                                                      placeholder: "请选择区域",
                                                      options: _ctx.region_list_2023
                                                    }, null, 8, ["value", "onUpdate:value", "options"])
                                                  ]),
                                                  _: 2
                                                }, 1032, ["label"])
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_a_col, { span: 10 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_input_number, {
                                                      min: 0,
                                                      max: 1,
                                                      step: 0.01,
                                                      value: item.default,
                                                      "onUpdate:value": ($event: any) => ((item.default) = $event),
                                                      placeholder: "1%请填写0.01"
                                                    }, null, 8, ["step", "value", "onUpdate:value"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024),
                                            _createVNode(_component_a_col, {
                                              span: 4,
                                              class: "btn_delete_container"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_button, {
                                                  type: "link",
                                                  onClick: ($event: any) => (_ctx.delete_region_item({ type: 'tt2023', index }))
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                                  ]),
                                                  _: 2
                                                }, 1032, ["onClick"])
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  }), 128)),
                                  _createVNode(_component_a_col, { span: 24 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_row, { gutter: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, { span: 10 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_form_item, null, {
                                                default: _withCtx(() => [
                                                  _hoisted_28
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_col, { span: 10 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_input_number, {
                                                    min: 0,
                                                    max: 1,
                                                    step: 0.01,
                                                    value: _ctx.model.tt2023.default.default,
                                                    "onUpdate:value": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.model.tt2023.default.default) = $event)),
                                                    placeholder: "1%请填写0.01"
                                                  }, null, 8, ["step", "value"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ACollapsePanel, {
                            key: "新客（阶梯1-4指标由低到高）",
                            header: "新客（阶梯1-4指标由低到高）"
                          }, {
                            extra: _withCtx(() => [
                              (_ctx.is_supply)
                                ? (_openBlock(), _createBlock(_component_a_button, {
                                    key: 0,
                                    type: "link",
                                    onClick: _cache[29] || (_cache[29] = _withModifiers(($event: any) => (
                      _ctx.add_step_item({ type: 'tt2023', tt2023_type: 'new_config', cost_or_ratio: 'cost' }),
                        _ctx.add_step_item({ type: 'tt2023', tt2023_type: 'new_config', cost_or_ratio: 'cost_ratio' })
                    ), ["stop"])),
                                    disabled: _ctx.model.tt2023.new_config.cost.steps.length === 4
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_29
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              (_ctx.is_supply)
                                ? (_openBlock(), _createBlock(_component_a_row, {
                                    key: 0,
                                    gutter: 24
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, {
                                        span: 24,
                                        class: "step_item_title mb_36"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_30
                                        ]),
                                        _: 1
                                      }),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt2023.new_config.cost.steps, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_a_col, {
                                          span: 24,
                                          key: index
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { gutter: 24 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 6 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "从" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          type: "text",
                                                          value: item.from,
                                                          "onUpdate:value": ($event: any) => ((item.from) = $event),
                                                          formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                                                          parser: (value) => value.replace(/\s?|(,*)/g, ''),
                                                          onChange: ($event: any) => (
                              _ctx.change_from_value({
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                cost_or_ratio: 'cost',
                                index,
                              })
                            )
                                                        }, null, 8, ["value", "onUpdate:value", "formatter", "parser", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 6 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "到" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          type: "text",
                                                          value: item.to,
                                                          "onUpdate:value": ($event: any) => ((item.to) = $event),
                                                          formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                                                          parser: (value) => value.replace(/\s?|(,*)/g, ''),
                                                          onChange: ($event: any) => (
                              _ctx.change_to_value({
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                cost_or_ratio: 'cost',
                                index,
                              })
                            )
                                                        }, null, 8, ["value", "onUpdate:value", "formatter", "parser", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          min: 0,
                                                          max: 1,
                                                          step: 0.01,
                                                          value: item.value,
                                                          "onUpdate:value": ($event: any) => ((item.value) = $event),
                                                          placeholder: "1%请填写0.01",
                                                          onChange: ($event: any) => (
                              _ctx.change_cost_or_ratio_value({
                                event: $event,
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                target: 'cost_ratio',
                                index,
                              })
                            )
                                                        }, null, 8, ["step", "value", "onUpdate:value", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, {
                                                  span: 4,
                                                  class: "btn_delete_container"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_button, {
                                                      type: "link",
                                                      onClick: ($event: any) => (
                            _ctx.delete_step_item({
                              type: 'tt2023',
                              tt2023_type: 'new_config',
                              cost_or_ratio: 'cost',
                              index,
                            }),
                              _ctx.delete_step_item({
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                cost_or_ratio: 'cost_ratio',
                                index,
                              })
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: _ctx.model.tt2023.new_config.cost.steps.length === 0 ? '返点比例' : '其它返点比例'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input_number, {
                                                min: 0,
                                                max: 1,
                                                step: 0.01,
                                                value: _ctx.model.tt2023.new_config.cost.default,
                                                "onUpdate:value": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.model.tt2023.new_config.cost.default) = $event)),
                                                placeholder: "1%请填写0.01"
                                              }, null, 8, ["step", "value"])
                                            ]),
                                            _: 1
                                          }, 8, ["label"])
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_a_col, {
                                        span: 24,
                                        class: "step_item_title mb_36"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_31
                                        ]),
                                        _: 1
                                      }),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt2023.new_config.cost_ratio.steps, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_a_col, {
                                          span: 24,
                                          key: index
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { gutter: 24 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 6 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "从" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          min: 0,
                                                          max: 1,
                                                          step: 0.01,
                                                          value: item.from,
                                                          "onUpdate:value": ($event: any) => ((item.from) = $event),
                                                          formatter: (value) => `${value * 100}%`,
                                                          parser: (value) => value.replace('%', ''),
                                                          onChange: ($event: any) => (
                              _ctx.change_from_value({
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                cost_or_ratio: 'cost_ratio',
                                index,
                              })
                            )
                                                        }, null, 8, ["step", "value", "onUpdate:value", "formatter", "parser", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 6 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "到" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          min: 0,
                                                          max: 1,
                                                          step: 0.01,
                                                          formatter: (value) => `${value * 100}%`,
                                                          parser: (value) => value.replace('%', ''),
                                                          value: item.to,
                                                          "onUpdate:value": ($event: any) => ((item.to) = $event),
                                                          onChange: ($event: any) => (
                              _ctx.change_to_value({
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                cost_or_ratio: 'cost_ratio',
                                index,
                              })
                            )
                                                        }, null, 8, ["step", "formatter", "parser", "value", "onUpdate:value", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          min: 0,
                                                          max: 1,
                                                          step: 0.01,
                                                          value: item.value,
                                                          "onUpdate:value": ($event: any) => ((item.value) = $event),
                                                          placeholder: "1%请填写0.01",
                                                          onChange: ($event: any) => (
                              _ctx.change_cost_or_ratio_value({
                                event: $event,
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                target: 'cost',
                                index,
                              })
                            )
                                                        }, null, 8, ["step", "value", "onUpdate:value", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, {
                                                  span: 4,
                                                  class: "btn_delete_container"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_button, {
                                                      type: "link",
                                                      onClick: ($event: any) => (
                            _ctx.delete_step_item({
                              type: 'tt2023',
                              tt2023_type: 'new_config',
                              index,
                              cost_or_ratio: 'cost_ratio',
                            }),
                              _ctx.delete_step_item({
                                type: 'tt2023',
                                tt2023_type: 'new_config',
                                index,
                                cost_or_ratio: 'cost',
                              })
                          )
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: _ctx.model.tt2023.new_config.cost_ratio.steps.length === 0 ? '返点比例' : '其它返点比例'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input_number, {
                                                min: 0,
                                                max: 1,
                                                step: 0.01,
                                                value: _ctx.model.tt2023.new_config.cost_ratio.default,
                                                "onUpdate:value": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.model.tt2023.new_config.cost_ratio.default) = $event)),
                                                placeholder: "1%请填写0.01"
                                              }, null, 8, ["step", "value"])
                                            ]),
                                            _: 1
                                          }, 8, ["label"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.is_demand)
                                ? (_openBlock(), _createBlock(_component_a_row, {
                                    key: 1,
                                    gutter: 24
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input_number, {
                                                min: 0,
                                                max: 1,
                                                step: 0.01,
                                                value: _ctx.model.tt2023.new_config.default,
                                                "onUpdate:value": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.model.tt2023.new_config.default) = $event)),
                                                placeholder: "1%请填写0.01"
                                              }, null, 8, ["step", "value"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ACollapsePanel, {
                            key: "代运营（阶梯1-4指标由低到高）",
                            header: "代运营（阶梯1-4指标由低到高）"
                          }, {
                            extra: _withCtx(() => [
                              (_ctx.is_supply)
                                ? (_openBlock(), _createBlock(_component_a_button, {
                                    key: 0,
                                    type: "link",
                                    onClick: _cache[33] || (_cache[33] = _withModifiers(($event: any) => (
                      _ctx.add_step_item({ type: 'tt2023', tt2023_type: 'agency_config', cost_or_ratio: 'cost' }),
                        _ctx.add_step_item({ type: 'tt2023', tt2023_type: 'agency_config', cost_or_ratio: 'cost_ratio' })
                    ), ["stop"])),
                                    disabled: _ctx.model.tt2023.agency_config.cost.steps.length === 4
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_32
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              (_ctx.is_supply)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 0,
                                    span: 24
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_row, { gutter: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_col, {
                                            span: 24,
                                            class: "step_item_title mb_36"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_33
                                            ]),
                                            _: 1
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt2023.agency_config.cost.steps, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_a_col, {
                                              span: 24,
                                              key: index
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_row, { gutter: 24 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_col, { span: 6 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_form_item, { label: "从" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_input_number, {
                                                              type: "text",
                                                              value: item.from,
                                                              "onUpdate:value": ($event: any) => ((item.from) = $event),
                                                              formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                                                              parser: (value) => value.replace(/\s?|(,*)/g, ''),
                                                              onChange: ($event: any) => (
                                _ctx.change_from_value({
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  cost_or_ratio: 'cost',
                                  index,
                                })
                              )
                                                            }, null, 8, ["value", "onUpdate:value", "formatter", "parser", "onChange"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_a_col, { span: 6 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_form_item, { label: "到" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_input_number, {
                                                              type: "text",
                                                              value: item.to,
                                                              "onUpdate:value": ($event: any) => ((item.to) = $event),
                                                              formatter: (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ','),
                                                              parser: (value) => value.replace(/\s?|(,*)/g, ''),
                                                              onChange: ($event: any) => (
                                _ctx.change_to_value({
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  cost_or_ratio: 'cost',
                                  index,
                                })
                              )
                                                            }, null, 8, ["value", "onUpdate:value", "formatter", "parser", "onChange"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_a_col, { span: 8 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_input_number, {
                                                              min: 0,
                                                              max: 1,
                                                              step: 0.01,
                                                              value: item.value,
                                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                                              placeholder: "1%请填写0.01",
                                                              onChange: ($event: any) => (
                                _ctx.change_cost_or_ratio_value({
                                  event: $event,
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  target: 'cost_ratio',
                                  index,
                                })
                              )
                                                            }, null, 8, ["step", "value", "onUpdate:value", "onChange"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_a_col, {
                                                      span: 4,
                                                      class: "btn_delete_container"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_button, {
                                                          type: "link",
                                                          onClick: ($event: any) => (
                              _ctx.delete_step_item({
                                type: 'tt2023',
                                tt2023_type: 'agency_config',
                                index,
                                cost_or_ratio: 'cost',
                              }),
                                _ctx.delete_step_item({
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  index,
                                  cost_or_ratio: 'cost_ratio',
                                })
                            )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128)),
                                          _createVNode(_component_a_col, { span: 24 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_form_item, {
                                                label: _ctx.model.tt2023.agency_config.cost.steps.length === 0 ? '返点比例' : '其它返点比例'
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_input_number, {
                                                    min: 0,
                                                    max: 1,
                                                    step: 0.01,
                                                    value: _ctx.model.tt2023.agency_config.cost.default,
                                                    "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.model.tt2023.agency_config.cost.default) = $event)),
                                                    placeholder: "1%请填写0.01"
                                                  }, null, 8, ["step", "value"])
                                                ]),
                                                _: 1
                                              }, 8, ["label"])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_a_col, {
                                            span: 24,
                                            class: "step_item_title mb_36"
                                          }, {
                                            default: _withCtx(() => [
                                              _hoisted_34
                                            ]),
                                            _: 1
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt2023.agency_config.cost_ratio.steps, (item, index) => {
                                            return (_openBlock(), _createBlock(_component_a_col, {
                                              span: 24,
                                              key: index
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_row, { gutter: 24 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_col, { span: 6 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_form_item, { label: "从" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_input_number, {
                                                              min: 0,
                                                              max: 1,
                                                              step: 0.01,
                                                              formatter: (value) => `${value * 100}%`,
                                                              parser: (value) => value.replace('%', ''),
                                                              value: item.from,
                                                              "onUpdate:value": ($event: any) => ((item.from) = $event),
                                                              onChange: ($event: any) => (
                                _ctx.change_from_value({
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  cost_or_ratio: 'cost_ratio',
                                  index,
                                })
                              )
                                                            }, null, 8, ["step", "formatter", "parser", "value", "onUpdate:value", "onChange"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_a_col, { span: 6 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_form_item, { label: "到" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_input_number, {
                                                              min: 0,
                                                              max: 1,
                                                              step: 0.01,
                                                              formatter: (value) => `${value * 100}%`,
                                                              parser: (value) => value.replace('%', ''),
                                                              value: item.to,
                                                              "onUpdate:value": ($event: any) => ((item.to) = $event),
                                                              onChange: ($event: any) => (
                                _ctx.change_to_value({
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  cost_or_ratio: 'cost_ratio',
                                  index,
                                })
                              )
                                                            }, null, 8, ["step", "formatter", "parser", "value", "onUpdate:value", "onChange"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_a_col, { span: 8 }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_a_input_number, {
                                                              min: 0,
                                                              max: 1,
                                                              step: 0.01,
                                                              value: item.value,
                                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                                              placeholder: "1%请填写0.01",
                                                              onChange: ($event: any) => (
                                _ctx.change_cost_or_ratio_value({
                                  event: $event,
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  target: 'cost',
                                  index,
                                })
                              )
                                                            }, null, 8, ["step", "value", "onUpdate:value", "onChange"])
                                                          ]),
                                                          _: 2
                                                        }, 1024)
                                                      ]),
                                                      _: 2
                                                    }, 1024),
                                                    _createVNode(_component_a_col, {
                                                      span: 4,
                                                      class: "btn_delete_container"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_button, {
                                                          type: "link",
                                                          onClick: ($event: any) => (
                              _ctx.delete_step_item({
                                type: 'tt2023',
                                tt2023_type: 'agency_config',
                                index,
                                cost_or_ratio: 'cost_ratio',
                              }),
                                _ctx.delete_step_item({
                                  type: 'tt2023',
                                  tt2023_type: 'agency_config',
                                  index,
                                  cost_or_ratio: 'cost',
                                })
                            )
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                                          ]),
                                                          _: 2
                                                        }, 1032, ["onClick"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128)),
                                          _createVNode(_component_a_col, { span: 24 }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_form_item, {
                                                label: _ctx.model.tt2023.agency_config.cost_ratio.steps.length === 0 ? '返点比例' : '其它返点比例'
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_a_input_number, {
                                                    min: 0,
                                                    max: 1,
                                                    step: 0.01,
                                                    value: _ctx.model.tt2023.agency_config.cost_ratio.default,
                                                    "onUpdate:value": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.model.tt2023.agency_config.cost_ratio.default) = $event)),
                                                    placeholder: "1%请填写0.01"
                                                  }, null, 8, ["step", "value"])
                                                ]),
                                                _: 1
                                              }, 8, ["label"])
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.is_demand)
                                ? (_openBlock(), _createBlock(_component_a_col, {
                                    key: 1,
                                    span: 24
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input_number, {
                                            min: 0,
                                            max: 1,
                                            step: 0.01,
                                            value: _ctx.model.tt2023.agency_config.default,
                                            "onUpdate:value": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.model.tt2023.agency_config.default) = $event)),
                                            placeholder: "1%请填写0.01"
                                          }, null, 8, ["step", "value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ACollapsePanel, {
                            key: "电商（阶梯1-4指标由低到高）",
                            header: "电商（阶梯1-4指标由低到高）"
                          }, {
                            extra: _withCtx(() => [
                              (_ctx.is_supply)
                                ? (_openBlock(), _createBlock(_component_a_button, {
                                    key: 0,
                                    type: "link",
                                    onClick: _cache[37] || (_cache[37] = _withModifiers(($event: any) => (_ctx.add_step_item({ type: 'tt2023', tt2023_type: 'store_config' })), ["stop"])),
                                    disabled: _ctx.model.tt2023.store_config.steps.length === 4
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_35
                                    ]),
                                    _: 1
                                  }, 8, ["disabled"]))
                                : _createCommentVNode("", true)
                            ]),
                            default: _withCtx(() => [
                              _createVNode(_component_a_col, { span: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_row, { gutter: 24 }, {
                                    default: _withCtx(() => [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.tt2023.store_config.steps, (item, index) => {
                                        return (_openBlock(), _createBlock(_component_a_col, {
                                          span: 24,
                                          key: index
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_row, { gutter: 24 }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_a_col, { span: 6 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "从" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          type: "text",
                                                          value: item.from,
                                                          "onUpdate:value": ($event: any) => ((item.from) = $event),
                                                          onChange: ($event: any) => (_ctx.change_from_value({ type: 'tt2023', tt2023_type: 'store_config', index }))
                                                        }, null, 8, ["value", "onUpdate:value", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 6 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "到" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          type: "text",
                                                          value: item.to,
                                                          "onUpdate:value": ($event: any) => ((item.to) = $event),
                                                          onChange: ($event: any) => (_ctx.change_to_value({ type: 'tt2023', tt2023_type: 'store_config', index }))
                                                        }, null, 8, ["value", "onUpdate:value", "onChange"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, { span: 8 }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_a_input_number, {
                                                          min: 0,
                                                          max: 1,
                                                          step: 0.01,
                                                          value: item.value,
                                                          "onUpdate:value": ($event: any) => ((item.value) = $event),
                                                          placeholder: "1%请填写0.01"
                                                        }, null, 8, ["step", "value", "onUpdate:value"])
                                                      ]),
                                                      _: 2
                                                    }, 1024)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_a_col, {
                                                  span: 4,
                                                  class: "btn_delete_container"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_a_button, {
                                                      type: "link",
                                                      onClick: ($event: any) => (_ctx.delete_step_item({ type: 'tt2023', tt2023_type: 'store_config', index }))
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["onClick"])
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1024)
                                          ]),
                                          _: 2
                                        }, 1024))
                                      }), 128)),
                                      _createVNode(_component_a_col, { span: 24 }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_form_item, {
                                            label: _ctx.model.tt2023.store_config.steps.length === 0 ? '返点比例' : '其它返点比例'
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_a_input_number, {
                                                min: 0,
                                                max: 1,
                                                step: 0.01,
                                                value: _ctx.model.tt2023.store_config.default,
                                                "onUpdate:value": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.model.tt2023.store_config.default) = $event)),
                                                placeholder: "1%请填写0.01"
                                              }, null, 8, ["step", "value"])
                                            ]),
                                            _: 1
                                          }, 8, ["label"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["activeKey"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              ((_ctx.is_jl2023_type || _ctx.is_gdt2023_type) && _ctx.is_rebate)
                ? (_openBlock(), _createBlock(_component_a_col, {
                    key: 9,
                    span: 24
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_36,
                              _createVNode(_component_a_button, {
                                type: "link",
                                onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.add_step_item({ type: 'gdt_jl_2023' }))),
                                disabled: _ctx.model.gdt_jl_2023.webeye_buy.steps.length === 4
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_37
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.gdt_jl_2023.webeye_buy.steps, (item, index) => {
                            return (_openBlock(), _createBlock(_component_a_col, {
                              span: 24,
                              key: index
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_row, { gutter: 24 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_a_col, { span: 10 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "行业" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_we_select, {
                                              value: item.industry,
                                              "onUpdate:value": ($event: any) => ((item.industry) = $event),
                                              placeholder: "请选择行业",
                                              options: _ctx.industry_items
                                            }, null, 8, ["value", "onUpdate:value", "options"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, { span: 10 }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_a_input_number, {
                                              min: 0,
                                              max: 1,
                                              step: 0.01,
                                              value: item.value,
                                              "onUpdate:value": ($event: any) => ((item.value) = $event),
                                              placeholder: "1%请填写0.01"
                                            }, null, 8, ["step", "value", "onUpdate:value"])
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_a_col, {
                                      span: 4,
                                      class: "btn_delete_container"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_button, {
                                          type: "link",
                                          onClick: ($event: any) => (_ctx.delete_step_item({ type: 'gdt_jl_2023', index }))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_svg_icon, { "icon-name": "DeleteOutlined" })
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_row, { gutter: 24 }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_col, { span: 10 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "行业" }, {
                                        default: _withCtx(() => [
                                          _hoisted_38
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_col, { span: 10 }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_input_number, {
                                            min: 0,
                                            max: 1,
                                            step: 0.01,
                                            value: _ctx.model.gdt_jl_2023.webeye_buy.default,
                                            "onUpdate:value": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.model.gdt_jl_2023.webeye_buy.default) = $event)),
                                            placeholder: "1%请填写0.01"
                                          }, null, 8, ["step", "value"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { gutter: 24 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 24,
                            class: "step_item_title mb_36"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_39
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_col, { span: 24 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_form_item, { label: "返点比例" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_input_number, {
                                    min: 0,
                                    max: 1,
                                    step: 0.01,
                                    value: _ctx.model.gdt_jl_2023.partner_buy.default,
                                    "onUpdate:value": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.model.gdt_jl_2023.partner_buy.default) = $event)),
                                    placeholder: "1%请填写0.01"
                                  }, null, 8, ["step", "value"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["visible", "after_close"]))
}